import axios, { type AxiosError, type AxiosHeaders, type AxiosResponse } from 'axios';
import { toast } from 'react-toastify';

import { snakeToCamelCase } from '@/lib/convert-code-style';

export interface CustomAxiosResponse<T = any> extends AxiosResponse<T> {
  message: string | undefined;
  data: any;
  statusCode: number;
}

export interface ApiResponse {
  msg?: string | undefined;
  message: string | undefined;
  data: any;
  statusCode: number;
}

export interface AxiosErr {
  config: any;
  data: any;
  headers: AxiosHeaders;
  request: XMLHttpRequest;
  status: number;
  statusText: string;
  statusCode: number;
}

export const customRes = <T>(response: AxiosResponse<ApiResponse>): CustomAxiosResponse<T> => {
  // response.data가 배열이거나 객체인지 확인
  let data = null;
  if (Array.isArray(response.data)) {
    // response.data가 배열인 경우
    data = response.data;
  }  else if (response.data?.data === null) {
    data = response.data?.data;
  }
  else if (response.data?.data) {
    // response.data.data가 있는 경우
    data = response.data?.data;
  } else if (response.data && typeof response.data === 'object') {
    // response.data가 객체인 경우
    data = response.data;
  } else {
    data = response.data;
  }

  let re = null;
  if (data && Array.isArray(data) && data.length > 0 && typeof data[0] === 'object') {
    // 배열이고 첫 번째 요소가 객체인 경우 (객체 배열)
    re = data.map((item: any) => snakeToCamelCase(item));
  } else if (data && Array.isArray(data)) {
    // 배열이지만 객체가 아닌 경우 (원시값 배열)
    re = data;
  } else if (data && typeof data === 'object' && !Array.isArray(data)) {
    // 객체인 경우
    re = snakeToCamelCase(data);
  } else {
    // 그 외의 경우 (null, undefined, 원시값 등)
    re = data;
  }
  const customResponse: CustomAxiosResponse<T> = {
    ...response,
    data: re, // data === null ? null ? typeof data[0] === 'object' ? data.map((item: any) => snakeToCamelCase(item)) : data.map((item: any) => snakeToCamelCase(item)),
    message: response.data?.message ? response.data?.message : response.data?.msg ? response.data?.msg : '',
    statusCode: response.data?.statusCode,
  };
  if (customResponse.data?.message) {
    delete customResponse.data.message;
  }
  return customResponse;
};

export const axiosErrors = (e: unknown, func: string): Promise<CustomAxiosResponse> => {
  let message = 'Unknown error';
  let statusCode = 0;
  let data = null;
  if (axios.isAxiosError(e)) {
    const axiosError = e;
    data = axiosError.response?.data?.data;
    statusCode = axiosError.response?.data?.statusCode || 400;
    if (axiosError.response) {
      const re: ApiResponse = axiosError.response.data as ApiResponse; // 강제 형변환
      console.error('Error response:', re?.message || re?.msg);
      message = re?.message || re?.msg || '';
      toast.error(message);
    } else if (axiosError.request) {
      console.error('No response received:', axiosError.request);
    } else {
      console.error('Error setting up the request:', message);
    }
  } else {
    console.error('Unknown error:', e);
  }
  // 오류 처리 후 빈 Promise를 반환
  return Promise.reject(new Error(`Error occurred during ${func}`)); // 또는 return Promise.resolve(); 등등
};
